import React, { Component } from 'react';
import withNavigate from '../../../core/withNavigate';
import PromoterController from './promoter.controller';
import Inherit from '../../../core/inherit';
import dayjs from 'dayjs';

import { Layout, Loading } from '../../common';
import { PromoterCalendar, PromoterRoute, PromoterTime, PromoterTitle, PromoterTrend } from './elements';

class ShelfPromoterProfile extends Inherit(PromoterController, Component) {
    state = {
        loading: true,
        promoter: null,
        calendars: [],
        storeChecks: [],
        date: dayjs(),
        dateRange: [dayjs().startOf('month'), dayjs()],
        filterMode: 'day',
        averageMinutes: 0,
        trendRange: [dayjs().subtract(3, 'month').startOf('day'), dayjs().endOf('day')],
        trendWeekday: 'all',
        trendSeries: [],
        trendLoading: false,
        trendStoreChecks: [],
        stores: [],
        isOpen: false,
        calendarLoading: false
    };

    render() {
        const {
            loading,
            promoter,
            date,
            dateRange,
            filterMode,
            storeChecks,
            averageMinutes,
            trendRange,
            trendWeekday,
            trendSeries,
            trendLoading,
            stores,
            calendars,
            isOpen,
            calendarLoading
        } = this.state;
        return (
            <Layout>
                {loading ? (
                    <Loading />
                ) : (
                    <div className="flex flex-col gap-4">
                        <PromoterTitle
                            date={date}
                            dateRange={dateRange}
                            filterMode={filterMode}
                            promotor={promoter}
                            setDate={this.setDate.bind(this)}
                            setDateRange={this.setDateRange.bind(this)}
                            setFilterMode={this.setFilterMode.bind(this)}
                            setLoading={this.setLoading.bind(this)}
                        />
                        <PromoterTime averageMinutes={averageMinutes} auditCount={storeChecks?.length || 0} assignedDays={calendars?.length || 0} />
                        <PromoterCalendar
                            stores={stores}
                            isOpen={isOpen}
                            calendarLoading={calendarLoading}
                            promotor={promoter}
                            calendars={calendars}
                            setIsOpen={this.setIsOpen.bind(this)}
                            createCalendar={this.createCalendar.bind(this)}
                        />
                        <PromoterRoute
                            stores={stores}
                            loading={loading}
                            storeChecks={storeChecks}
                            navigateStoreCheck={this.navigateStoreCheck.bind(this)}
                        />
                        <PromoterTrend
                            range={trendRange}
                            weekday={trendWeekday}
                            series={trendSeries}
                            loading={trendLoading}
                            setRange={this.setTrendRange.bind(this)}
                            setWeekday={this.setTrendWeekday.bind(this)}
                        />
                    </div>
                )}
            </Layout>
        );
    }
}

export default withNavigate(ShelfPromoterProfile);
